/**
 * Blog/product images are stored as `/uploads/...` on the API host.
 * The React dev server (e.g. :3000) does not serve those; prepend API origin from REACT_APP_API_URL.
 */
export function resolveUploadUrl(pathOrUrl: string | null | undefined): string | null | undefined {
  if (pathOrUrl == null || pathOrUrl === '') return pathOrUrl;
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;

  const explicitBase =
    (process.env.REACT_APP_UPLOAD_BASE_URL || process.env.REACT_APP_CLOUDFRONT_URL || '').replace(/\/$/, '');
  const api = process.env.REACT_APP_API_URL || '';
  const apiOrigin = api.replace(/\/api\/?$/, '').replace(/\/$/, '');
  const base = explicitBase || apiOrigin;

  if (!base) return pathOrUrl;
  return `${base}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}

export function withResolvedBlogImage<T extends { image?: string | null }>(record: T): T {
  if (!record?.image) return record;
  return { ...record, image: resolveUploadUrl(record.image) as string };
}
